import { Stack, Typography } from "@mui/material";

const PageMainStack = (props) => {
    const { children, title=null } = props;
    return <Stack justifyContent="space-evenly" spacing={2} >
        { title ? <Typography variant="h3">{title}</Typography> : <></>}
        {children}
        </Stack>
}
export default PageMainStack